import React, { Component } from "react";
import "./CashAdvance.css";
import SideNav from "../sidenav/Sidenav.js";
import { CrfContext } from "../../CrfContext";
import { Redirect } from "react-router-dom"

import { Transition, animated } from "react-spring/renderprops";

import CashAdvanceView from "./CashAdvanceView"

import axios from "axios"
import CashAdvanceModal from "./CashAdvanceModal";

export class CashAdvance extends Component {

  state = {
    hasApprovedDept: false,
    userDeptList: [],

    showBanner: true,
    showForm: false,
    showPage1: false,
    showPage2: false,

    vendor: '',
    vendorError: false,
    vendorErr: 1,
    particulars: '',
    particularsError: false,
    particularsErr: 1,
    requestingDepartment: "",
    poNumber: 1,
    poNumberError: false,
    poNumberErr: 1,
    project: '',
    projectError: false,
    projectErr: 1,
    subProject: '',
    file: null,
    fileError: false,
    fileErr: 1,
    
    projectClass: [
        {
          glCategory: "",
          glAccount: "",
          description1: "",
          description2: "",
          itemNumber: "",
          grossPricePerItem: 0,
          netPricePerItem: 0,
          quantity: 1,
          costType: "1OV",
          vatType: "",
          vatTypeValue: 1,
          wTax: 0,
          wTaxType:"X1",
          wTaxTypeValue: 0,
          wTaxTypeString: "",
          unitPrice: 0,
          subNetPrice: 0,
          projectClass: ""
      },
    ],
    glCategory: "",
    projectCode: '',
    vendorLists: [],
    departmentLists: [],
    projectLists: [],
    projectCode: "",
    accountTypes: [],
    itemNoList:[],

    redirect: false,
    crfId: "",

vendorListEmpty: false,
updateForm: false,
advancesProjectClass: [],

subNetList: [],

vatTypeSelector: "",
vatTypeSelected: "",

wTaxRates: [],

vendorLists: [],
projectLists: [],

error: 0,

removal: false,
target: null,
addProjectClass: false,
}

componentDidMount(){
    
  setTimeout(() => {
    this.setState({
      showForm: true
    })
  }, 500)

       // ===================================================================
      // GET VENDOR LIST
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/vendors`,
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          // document.getElementById('main').style.display = 'block'
          console.log(response)
          this.setState({
            vendorLists: response.data.data
          })
          console.log(this.state.vendorLists)
      })
      .catch(error => {
          console.log(error.response)   
        })

    //================================================================================
      
      // GET PROJECT LIST
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/projects`,
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          console.log(response)
          this.setState({
            projectLists: response.data.data
          })
      })
      .catch(error => {
          console.log(error.response)   
        })
  // =========================================================

  axios({
    method: 'GET',
    url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
    headers: {
      'Api-Key':
        '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
      Authorization: `Bearer ${localStorage.token}`
    }
  })
    .then(response => {
      console.log(response)
      this.setState({
        userDeptList: response.data.data.departments
      })
      let hasApproved = false
      for (let i = 0; i < response.data.data.departments.length; i++) {
        console.log(response.data.data.departments[i].isApproved)
        if(response.data.data.departments[i].isApproved === true){
            hasApproved = true
        }  

        if(response.data.data.roles[0] !== "Requestor"){
            this.setState({
                redirect: true,
                crfId: "/RequestSelection"
            })
        }
    }

        this.setState({
            // userRole: response.data.data.roles[0],
            // userName: response.data.data.firstName
            //  + " " + response.data.data.lastName,
            // requestingDepartment: response.data.data.department.centerName,
            // userId: response.data.data._id
        })
  })
  .catch(error => {
      console.log(error.response)   
    })

  }

  checkStateValue = (e) => {
    e.preventDefault()
    console.log(this.state)
  }

// END OF COMPONENT DID MOUNT

  handleChangeRequestField = (e) => {
    e.preventDefault()
    
    if(e.target.name === "vendor"){
        this.setState({vendorError: true})
        axios({
          method: 'GET',
          url: `${process.env.REACT_APP_API_KEY}/api/vendors/${e.target.value}`,
          headers: {
            'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
            Authorization: `Bearer ${localStorage.token}`
          }
        })
          .then(response => {
            console.log(response.data.data.bpCode)
              this.setState({
                vatTypeSelector: response.data.data.vatType
              })
      // ==================================================================================
      // VENDOR BP CODE WILL GET THE WTAX
      
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/withHoldingTax/wTaxCode/${response.data.data.bpCode}`,
        headers: {
          'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          console.log(response)
          let newArray = response.data.data
          const none = {
            wTaxCode: "X1",
            wTaxName: "",
            wTaxDisplayName: "None ",
            rate: "0",
          }
          newArray.push(none)
          this.setState({
            wTaxRates: newArray
          })
          console.log(this.state.wTaxRates)
      })
      .catch(error => {
          console.log(error.response)
        })
  
       // ==================================================================================
        })
        .catch(error => {
            console.log(error.response)
          })

          if(!this.state.vendorLists.includes(document.getElementById(`${e.target.id}`).value)){
            document.getElementById(`${e.target.id}`)
             .nextElementSibling.nextElementSibling.children[0].innerText = "Invalid Input"
             document.getElementById(`${e.target.id}`)
             .nextElementSibling.nextElementSibling.children[1].innerText = 
             " " + "(Please input a valid data included in the list)"
             this.setState({vendorErr: 1})
           }else{
             document.getElementById(`${e.target.id}`)
             .nextElementSibling.nextElementSibling.children[0].innerText = ""
             document.getElementById(`${e.target.id}`)
             .nextElementSibling.nextElementSibling.children[1].innerText = ""
             this.setState({vendorErr: 0})
           }
          }
          if(e.target.name === "particulars"){
            this.setState({particularsError: true})
            if(e.target.value === ""){
              this.setState({particularsErr: 1})
            }else{
              this.setState({particularsErr: 0})
            }
          }

      if(e.target.name === "project"){
        
        for (let i = 0; i < this.state.projectClass.length; i++) {
        this.setState(()=> this.state.projectClass[i].glCategory = "")
       }
// ================================================================================================
      this.setState({projectError: true, projectErr: 1})
      if(!this.state.projectLists.includes(document.getElementById(`${e.target.id}`).value)){
        document.getElementById(`${e.target.id}`)
        .nextElementSibling.nextElementSibling.children[0].innerText = "Invalid Input"
        document.getElementById(`${e.target.id}`)
        .nextElementSibling.nextElementSibling.children[1].innerText = 
        " " + "(Please input a valid data included in the list)"
        this.setState({projectErr: 1})
        
      }else{
        document.getElementById(`${e.target.id}`)
        .nextElementSibling.nextElementSibling.children[0].innerText = ""
        document.getElementById(`${e.target.id}`)
        .nextElementSibling.nextElementSibling.children[1].innerText = ""
        this.setState({projectErr: 0})
      } 
      
      if(e.target.value === ""){
        document.getElementById(`${e.target.id}`)
        .nextElementSibling.nextElementSibling.children[0].innerText = ""
        document.getElementById(`${e.target.id}`)
        .nextElementSibling.nextElementSibling.children[1].innerText = ""
        this.setState({projectErr: 1})
      }

      // =======================================================
    }

    if(e.target.name === "file" && e.target.files.length !== 0){
      let fileName = e.target.files[0].name.split('.')
      let fileExtension = fileName[1]
      this.setState({fileError: true})
      console.log(e.target.file)
      console.log(fileExtension)
      if(fileExtension !== 'pdf'){
        this.setState({fileErr: 1})
        console.log('error')
      }else{
        this.setState({fileErr: 0})
        console.log('success')
      }
    }

    if(e.target.name === "file" && e.target.files.length === 0){
      this.setState({fileErr: 1})

    }
    
    // GET THE PARTICULAR VAT TYPE FOR SELECTED VENDOR

    // ================================================================

    // this.setState({
    //   [e.target.name]: e.target.value,
    //   requestingDepartment: document.getElementById("departmentInput").value
    // })
    // this.setState(()=> this.state.(e.target.name) = e.target.value)

    // CHANGE GL CATEGORY SELECTIONS
       // for (let i = 0; i < glCategoryClass.length; i++) {
      //   console.log('test')
      //   glCategoryClass[i].value = ""
      //   this.setState(()=> this.state.projectClass[i].glCategory = "")
      // }
    
    if(e.target.name === "project"){
      this.setState({
        accountTypes: []
      })
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/projects/${e.target.value}`,
        headers: {
          'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          console.log(response)
          this.setState({
              projectCode: response.data.data.projectCode
          })
          console.log(this.state.projectCode)


          axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/glAccountTypes/${response.data.data.projectCode}`,
            headers: {
              'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              console.log(response)
              this.setState({
                accountTypes: response.data.data
            })
            console.log(this.state.accountTypes)
          })
          .catch(error => {
              console.log(error.response)
              this.setState({
                accountTypes: []
            })   
          })
      })
      .catch(error => {
          console.log(error.response)   
        })
      
    }


    if(e.target.name === "file" && e.target.files.length !== 0){
      let fileName = e.target.files[0].name.split('.')
      let fileExtension = fileName[1]
      fileExtension !== 'pdf' ? 
      document.getElementById('documentEmptyError')
      .innerText = "(Please upload a valid file(pdf).)":
      document.getElementById('documentEmptyError').innerText = ""
    }

    let file = null
    if(e.target.name === "file"){
      console.log(e.target.files[0])
     file = (e.target.files[0])
      console.log(file)
      this.setState({
        [e.target.name]: e.target.files[0],
      })
    }else{
      this.setState({
        [e.target.name]: e.target.value,
      })
    }
      console.log(this.state.accountTypes)

      this.setState({error: this.state.vendorErr + this.state.particularsErr
         + this.state.projectErr + this.state.fileErr})
      console.log(this.state)
  }


  handleProjectInputFunction = (e) => {
    // if(e){
      e.preventDefault()
    // }
    
    let glCategoryClass = document.getElementsByClassName("glCategoryClass")

    for (let i = 0; i < glCategoryClass.length; i++) {
      console.log('test')
      glCategoryClass[i].value = ""
      // this.setState(()=> this.state.projectClass[i].glCategory = "")
    }
 
  }




  
    handleChangeProjectClassValue = (e) =>{

      let projectClassCopy = [...this.state.projectClass]
      console.log(e.target.value)
      projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value

      // EXTRACT GL ACCOUNT NAME
      let glAccountValue = ""
          if(e.target.name === 'glAccount'){
            glAccountValue = e.target.value
            console.log(glAccountValue.substring(0,10))
            projectClassCopy[parseInt(e.target.id)].glAccount = glAccountValue.substring(0,10)
            console.log(this.state.projectClass)
          }

      // CHANGE GL NAME LISTS
      if(e.target.value === "COC Expenses"){
        document.getElementById(`${parseInt(e.target.id)}`).nextElementSibling
        .nextElementSibling.setAttribute("list", "cocExpenses")
      }

      if(e.target.value === "Advances"){
        document.getElementById(`${parseInt(e.target.id)}`).nextElementSibling
        .nextElementSibling.setAttribute("list", "advances")
      }

      if(e.target.value === "Admin Expenses"){
        document.getElementById(`${parseInt(e.target.id)}`).nextElementSibling
      .nextElementSibling.setAttribute("list", "adminExpenses")
      }

      if(e.target.value === "PPE Accounts"){
        document.getElementById(`${parseInt(e.target.id)}`).nextElementSibling
      .nextElementSibling.setAttribute("list", "ppeAccounts")
      }

      if(e.target.name === "glCategory"){
        e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.value= ''
        document.getElementById(`${parseInt(e.target.id)}`).nextElementSibling
        .nextElementSibling.value = ""
        projectClassCopy[parseInt(e.target.id)].glAccount = ""
         projectClassCopy[parseInt(e.target.id)].projectClass = ""
      // CHANGE PROJECT CLASS LOOP
        // for (let i = 0; i < projectClassCopy.length; i++) {
        //   console.log('test')
        //   projectClassCopy[i].glAccount = ""
        // }
      }

      if(e.target.name === "quantity" || e.target.name === "grossPricePerItem"){
        projectClassCopy[parseInt(e.target.id)][e.target.name] = parseFloat(e.target.value)
        this.setState({projectClass: projectClassCopy})
    }

      // ==========================================================================
      //ITEM NUMBER DATALIST 
      // axios({
      //   method: 'GET',
      //   url: `${process.env.REACT_APP_API_KEY}/api/itemNo/DC`,
      //   headers: {
      //     'Api-Key':
      //       '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
      //     Authorization: `Bearer ${localStorage.token}`
      //   }
      // })
      //   .then(response => {
      //     console.log(response)
      // })
      // .catch(error => {
      //     console.log(error.response)   
      //   })
        
      this.setState({
        projectClass: projectClassCopy
      })
      
      if(e.target.name === "vatType"){
            // projectClassCopy[parseInt(e.target.id)].wTaxTypeValue = wTaxRate * 0.01
            projectClassCopy[parseInt(e.target.id)].wTax = projectClassCopy[parseInt(e.target.id)].unitPrice *
              projectClassCopy[parseInt(e.target.id)].wTaxTypeValue
            projectClassCopy[parseInt(e.target.id)].netPricePerItem = projectClassCopy[parseInt(e.target.id)].grossPricePerItem -
              projectClassCopy[parseInt(e.target.id)].wTax
            
            this.setState({
              projectClass: projectClassCopy
            })  
      }
      
      if(e.target.name === "wTaxType"){
        console.log(this.state.wTaxRates) 
          let wTaxRate = parseInt(this.state.wTaxRates.filter(rate => rate.wTaxCode === e.target.value)[0].rate)
            projectClassCopy[parseInt(e.target.id)].wTaxTypeValue = wTaxRate * 0.01
            projectClassCopy[parseInt(e.target.id)].wTax = projectClassCopy[parseInt(e.target.id)].unitPrice *
              projectClassCopy[parseInt(e.target.id)].wTaxTypeValue
            projectClassCopy[parseInt(e.target.id)].netPricePerItem = projectClassCopy[parseInt(e.target.id)].grossPricePerItem -
              projectClassCopy[parseInt(e.target.id)].wTax
            // console.log(this.state.wTaxRates.filter(rate => rate.wTaxCode === e.target.value)[0].rate)
            this.setState({
            projectClass: projectClassCopy
          })  
      }
      

      if(e.target.name === 'glCategory' && e.target.value === "Advances"){
        e.target.nextElementSibling.nextElementSibling.nextElementSibling.style.display = 'block'
        e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.style.display = 'block'
      }else if(e.target.name === 'glCategory' && e.target.value !== "Advances"){
        e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.style.display = 'none'
        e.target.nextElementSibling.nextElementSibling.nextElementSibling.style.display = 'none'
        // console.log(e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling)
      }

      // GET THE VAT TYPE VALUE
      projectClassCopy[parseInt(e.target.id)].vatType === "Goods IVAT-G" ||
      projectClassCopy[parseInt(e.target.id)].vatType === "Services IVAT-S" ?
      projectClassCopy[parseInt(e.target.id)].vatTypeValue = 1 + 0.12 :
      projectClassCopy[parseInt(e.target.id)].vatTypeValue = 1
      
  //  THIS IS THE COMPUTATION FOR SUB TOTAL GROSS PRICE AND UNIT PRICE
      // GET UNIT PRICE
      let unitPriceToFix =  projectClassCopy[parseInt(e.target.id)].grossPricePerItem /
      projectClassCopy[parseInt(e.target.id)].vatTypeValue
      let unitPriceFixed = unitPriceToFix.toFixed(2)
      projectClassCopy[parseInt(e.target.id)].unitPrice = parseInt(unitPriceFixed)
    
      //GET WTAX
      // if(projectClassCopy[parseInt(e.target.id)].unitPrice !== NaN &&
      //   projectClassCopy[parseInt(e.target.id)].unitPrice !== 0 &&
      //   projectClassCopy[parseInt(e.target.id)].wTaxTypeValue !== NaN &&
      //   projectClassCopy[parseInt(e.target.id)].wTaxTypeValue !== 0){
      //     projectClassCopy[parseInt(e.target.id)].wTax =
      //     projectClassCopy[parseInt(e.target.id)].unitPrice *
      //     projectClassCopy[parseInt(e.target.id)].wTaxTypeValue
      // }

      // GET NET PRICE PER ITEM
      // if(projectClassCopy[parseInt(e.target.id)].wTax !== NaN &&
      //   projectClassCopy[parseInt(e.target.id)].wTax !== 0){
      //     projectClassCopy[parseInt(e.target.id)].netPricePerItem =
      //     projectClassCopy[parseInt(e.target.id)].grossPricePerItem -
      //     projectClassCopy[parseInt(e.target.id)].wTax
      //   }
        
        //GET SUBNET PRICE PER ITEM
        projectClassCopy[parseInt(e.target.id)].subNetPrice =
        projectClassCopy[parseInt(e.target.id)].netPricePerItem *
        projectClassCopy[parseInt(e.target.id)].quantity

        // THIS WILL COMPUTE IN TOTAL GROSS PRICE AND TOTAL NET PRICE IN PAGE 2 OF FORM
        console.log(document.getElementsByClassName("subTotalGrossPrice"))
        let subTotalGrossPrice = document.getElementsByClassName("subTotalGrossPrice")
        let subTotalNetPrice = document.getElementsByClassName("subTotalNetPrice")
        let requestingGrossPrice = document.getElementById("requestingGrossPrice")
        let requestingAmount = document.getElementById("requestingAmount")
        let requestingGrossPriceValue = 0
        let requestingAmountValue = 0
        for (let i = 0; i < this.state.projectClass.length; i++) {
          subTotalGrossPrice[i].innerText = (projectClassCopy[i].grossPricePerItem *
              projectClassCopy[i].quantity).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          requestingGrossPriceValue = requestingGrossPriceValue + (projectClassCopy[i].grossPricePerItem *
          projectClassCopy[i].quantity)

          subTotalNetPrice[i].innerText = (projectClassCopy[i].netPricePerItem *
              projectClassCopy[i].quantity).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          requestingAmountValue = requestingAmountValue + (projectClassCopy[i].netPricePerItem *
            projectClassCopy[i].quantity)
        }

        requestingGrossPrice.innerText = (requestingGrossPriceValue).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        requestingAmount.innerText = (requestingAmountValue).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        

        console.log(this.state.projectClass)
        console.log(parseInt(e.target.id))
        console.log(this.state.projectClass[e.target.id])
      }


  addProjectClass = (e) => {
    e.preventDefault()
    this.setState({
      addedProjectClass: true,
      projectClass: [
        ...this.state.projectClass,
        {
          glCategory: "",
          glAccount: "",
          description1: "",
          description2: "",
          itemNumber: "",
          grossPricePerItem: 0,
          netPricePerItem: 0,
          quantity: 1,
          costType: "1OV",
          vatType: "",
          vatTypeValue: 1,
          wTax: 0,
          wTaxType:"X1",
          wTaxTypeValue: 0,
          wTaxTypeString: "",
          unitPrice: 0,
          subNetPrice: 0,
          projectClass: ""
        }
      ]
    })
    // this.state.projectClass.push(
    //   {
    //           glCategory: "",
    //           glAccount: "",
    //           description1: "",
    //           description2: "",
    //           itemNumber: "",
    //           grossPricePerItem: 0,
    //           netPricePerItem: 0,
    //           quantity: 1,
    //           costType: "1OV",
    //           vatType: "",
    //           vatTypeValue: 1,
    //           wTax: 0,
    //           wTaxType:"X1",
    //           wTaxTypeValue: 0,
    //           wTaxTypeString: "",
    //           unitPrice: 0,
    //           subNetPrice: 0,
    //           projectClass: ""
    //         }
    // )
    console.log(this.state.projectClass)

  }

  handleSubmitNonPo = (e) =>{
    e.preventDefault()
    document.getElementById('modalBody').style.display = 'block';
    document.getElementById('page1').style.display = 'block'
    let array = this.state.projectClass

    let formData = new FormData();
    
    let nonPoForm = {

      department: this.state.requestingDepartment,
      departmentApprover: '5def0fc26501e01d3c1b3b45',
      vendor: this.state.vendor,
      project: this.state.project,
      projectClasses: this.state.projectClass,
      // dueDate: this.state.dateNeeded,
      subProject: this.state.subProject,
      particulars: this.state.particulars,
      requestType: "Cash Advance",
      status: "For Approval",
      unitPrice: this.state.unitPrice,
    }

    formData.set('crfForm', JSON.stringify(nonPoForm))
    formData.append("supportingDocuments", this.state.file)

    axios({
      method: 'POST',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      }
    })
      .then(response => {
        console.log(response)
        console.log(response.data.Data._id)
        this.setState({
            redirect: true,
            crfId: `/CheckRequest/${response.data.Data._id}`
          })
          document.getElementById('modalBody').style.display = 'none';
       console.log(this.state.redirect)

    })
    .catch(error => {
        console.log(error.response)
        document.getElementById('modalBody').style.display = 'none';
        
        alert('Please complete the fields before submitting')
      error.response.data.Error === "Supporting documents is required"
      ? document.getElementById('page1').style.display = "block"
      : document.getElementById('page1').style.display = "none"
      
        document.getElementById('formHintContainer').style.display = "block"
        document.getElementById('errorHint').innerText = 
        " " + "Please make sure you filled up the required fields at Project Class" +
        " " + (parseInt((error.response.data.Error).slice(-1)) + 1)
        // document.getElementById("form-validation-error").innerText = "Please fill out the required fields or check if your input is correct"
      })
}

handleDraftNonPo = (e) =>{
      // e.preventDefault()
      document.getElementById('page1').style.display = 'block'
      let array = this.state.projectClass

      let formData = new FormData();
      
      let nonPoForm = {
        department: this.state.requestingDepartment,
        // departmentApprover: '5def0fc26501e01d3c1b3b45',
        vendor: this.state.vendor,
        projectName: this.state.project,
        projectClass: this.state.projectClass,
        dueDate: this.state.dateNeeded,
        subProject: this.state.subProject,
        particulars: this.state.particulars,
        requestType: "Cash Advance",
        status: "Draft",
        unitPrice: this.state.unitPrice,
      }

      formData.set('crfForm', JSON.stringify(nonPoForm))
      formData.append("supportingDocuments", this.state.file)

      axios({
        method: 'POST',
        url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/draft`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`,
        }
      })
        .then(response => {
          console.log(response)
          this.setState({
              redirect: true,
              crfId: `/Draft/${response.data.data.insertedIds[0]}`
            })
         console.log(this.state.redirect)
      })
      .catch(error => {
          console.log(error.response)
        })
  }

  handleRemoveProjectClass = (e) => {
    console.log(e.target)
    console.log(e.target.name)
    // if(!this.state.csvToDl.includes(e.target.id)){
    //   this.state.csvToDl.push(e.target.id)
    //   console.log(this.state.csvToDl)
    // }else{
    //   if(this.state.csvToDl.indexOf(e.target.id) === 0){
    //     this.state.csvToDl.shift()
    //   }else{
    //     this.state.csvToDl.splice(this.state.csvToDl.indexOf(e.target.id), 1)
    //   }
      
    //   console.log(this.state.csvToDl)

    // }
    // this.state.projectClass.splice(parseInt(e.target.id), 1)
    // console.log(this.state.projectClass)
    this.setState({
      target: parseInt(e.target.name),
      removal: true
    })
    this.setState({
      // target: parseInt(e.target.name),
      removal: false
    })
  }



  render() {

    let vatTypeSelections = ""
      if(this.state.vatTypeSelector == ""){
        vatTypeSelections = 
        <>
          <option value="" disabled selected hidden>Please Choose...</option>
          <option value="None IVAT-X1">None IVAT-X1</option>
          <option value="Goods IVAT-G">Goods IVAT-G</option>
          <option value="Services IVAT-S">Services IVAT-S</option>
        </>
      }else if(this.state.vatTypeSelector == "IVAT-G"){
        vatTypeSelections = <>
          <option value="" disabled selected hidden>Please Choose...</option>
          <option value="None IVAT-X1">None IVAT-X1</option>
          <option value="Goods IVAT-G">Goods IVAT-G</option>
        </>
          // for (let i = 0; i < this.state.projectClass.length; i++) {
          //   this.state.projectClass[i].vatType = "Goods IVAT-G"
          // }
          // console.log(this.state.projectClass)
      }
      else if(this.state.vatTypeSelector == "IVAT-S"){
        vatTypeSelections = <>
          <option value="" disabled selected hidden>Please Choose...</option>
          <option value="None IVAT-X1">None IVAT-X1</option>
          <option value="Services IVAT-S">Services IVAT-S</option>
        </>
        // for (let i = 0; i < this.state.projectClass.length; i++) {
        //   this.state.projectClass[i].vatType = "Services IVAT-S"
        // }
        // console.log(this.state.projectClass)
      }else if(this.state.vatTypeSelector == "X1"){
        vatTypeSelections = <>
          <option value="None IVAT-X1">None IVAT-X1</option>
        </>
         for (let i = 0; i < this.state.projectClass.length; i++) {
          this.state.projectClass[i].vatType = "None IVAT-X1"
        }
        // console.log(this.state.projectClass)
      }

      if (this.state.redirect === true) {
        return <Redirect to={this.state.crfId} />
      }

      
    
    return (
    // <CrfContext.Consumer>
    //   {(context) => (
          <form id="mainPage">
            <CashAdvanceModal/>
          <div id="sidePanel">
            <SideNav 
              // testState = {context.state.testState}
              // toggleBtn1List = {context.toggleBtn1List}
              // toggleBtn2List = {context.toggleBtn2List}
              // btn1List = {context.state.btn1List}
              // btn2List = {context.state.btn2List}
              // userRole = {context.state.userRole}
            />
          </div>
          <div id="mainPanel">
          {/* BANNER */}
            <Transition
                native
                items={this.state.showBanner}
                from={{ opacity: 0, marginTop: -500}}
                enter={{ opacity: 1, marginTop: 0}}
                leave={{ opacity: 0, marginTop: -500}}
                // config={{ duration: 1000 }}
            >
                  {show => show && (props => (
                    <animated.div style={props}>
                        <div className="requestFormBanner">
                          <h1>CASH ADVANCE</h1>
                        </div>
                    </animated.div>
                              ))}
            </Transition>
        {/* END OF BANNER */}
        {/* FORM */}
        <div className="formContainer">
        <Transition
                native
                items={this.state.showForm}
                from={{ opacity: 0,}}
                enter={{ opacity: 1,}}
                leave={{ opacity: 0,}}
                config={{ duration: 300 }}
            >
                  {show => show && (props => (

                    <animated.div style={props}>                      
                         <CashAdvanceView
                            // userDepartment = {context.state.userDepartment}
                            // vendorLists = {context.state.vendorLists} 
                            // projectLists = {context.state.projectLists}
                            // cocExpenses = {context.state.cocExpenses}
                            // advances = {context.state.advances}
                            // ppeAccounts = {context.state.ppeAccounts}
                            // adminExpenses = {context.state.adminExpenses}
                            // advancesProjectClass = {context.state.advancesProjectClass}
                            userDeptList = {this.state.userDeptList}

                            vendor = {this.state.vendor}
                            vendorError = {this.state.vendorError}
                            vendorErr = {this.state.vendorErr}
                            particulars = {this.state.particulars}
                            particularsError = {this.state.particularsError}
                            particularsErr = {this.state.particularsErr}
                            project = {this.state.project}
                            projectError = {this.state.projectError}
                            projectErr = {this.state.projectErr}
                            file = {this.state.file}
                            fileError = {this.state.fileError}
                            fileErr = {this.state.fileErr}

                            projectClass = {this.state.projectClass}
                            accountTypes = {this.state.accountTypes}
                            vatTypeSelector = {this.state.vatTypeSelector}
                            vatTypeSelections = {vatTypeSelections}
                            wTaxRates = {this.state.wTaxRates}

                            handleChangeRequestField = {this.handleChangeRequestField}
                            handleChangeProjectClassValue = {this.handleChangeProjectClassValue}
                            addProjectClass = {this.addProjectClass}
                            handleSubmitNonPo = {this.handleSubmitNonPo}
                            handleDraftNonPo = {this.handleDraftNonPo}

                            checkStateValue = {this.checkStateValue}
                            file = {this.state.file}
                            vendorLists = {this.state.vendorLists}
                            projectLists = {this.state.projectLists}

                            handleRemoveProjectClass = {this.handleRemoveProjectClass}
                            addedProjectClass = {this.state.addedProjectClass}
                         />
                    </animated.div>
                              ))}
            </Transition>
            </div>
        {/* END OF FORM */}
          </div>
        </form>

    //   )}
    // </CrfContext.Consumer>
    );
  }
}

const dark = {
  color: 'black'
}

export default CashAdvance;
